module.exports = __webpack_public_path__ + "img/inehunaya.1aee373a.png";